import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import Button from '@/components/@base/button';
import { convertToEnglishNumber, currency } from '@/lib/helper';
// import {startAuthentication } from '@simplewebauthn/browser';
import cn from '@/lib/clsxm';
// import samanBankLogo from '@/assets/logos/saman-bank-logo.svg';
import { createTransactionResType } from '@/services/models/api.models';
import { usePostConfirm } from '@/services/hooks';
import { useNavigate } from 'react-router-dom';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import useHomeStore from '@/store/home';
import { SIZE_ENUM } from '@/components/@base/@types';
import React, { useState } from 'react';
import { INPUT_TYPES } from '@/components/@base/input/text/type';
import Input from '@/components/@base/input/text';
const MAX_INPUT_LENGTH = 30;
const PreInvoice = ({data}: {data?:createTransactionResType}) => {
  if(!data) return null
  const {ipgAmount, clientSelectedVouchers, selectedSegmentResponseItems, hasPasskey, isOtpRequired} = data
  const {mutate, isPending} = usePostConfirm()
  // const { mutate:mutateLoginOptions, isPending:loginPending } = usePostLoginOptions();
  // const { mutate: mutateLoginComplete, isPending: loginCompletePending } = usePostLoginComplete();
  const { setShowBottomSheet } = useBottomSheetStore();
  const { isActiveRequest, setIsActiveRequest, invoice } = useHomeStore();
  const [otp, setOtp] = useState<string | ''>('');
  const [userAcceptOtp, setUserAcceptOtp] = useState<boolean>(false);
  const navigate = useNavigate();
  const invoiceItems = [
    // {
    //   title: 'مجموع کسر از فاکتور',
    //   value: totalDeductionFromInvoice ? totalDeductionFromInvoice : 0
    // },
    {
      title: 'باقیمانده فاکتور',
      value: ipgAmount ? ipgAmount : 0
    },
  ]
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const numericValue = convertToEnglishNumber(rawValue);
    if (rawValue.length > MAX_INPUT_LENGTH) return;
    if (isNaN(+numericValue)) return;
    if (+numericValue < 0) return;
    setOtp(numericValue);
  };
  const handleConfirm = () => {
    const body:{WalletProviderOTP?:string} = {}
    if(otp) body.WalletProviderOTP = otp
    setIsActiveRequest(true)
    mutate(body, {
      onSuccess: (res) => {
        if(res.redirectToIPG) {
          window.location.assign(res.ipgUrl)
        } else if(!res.redirectToIPG && !res.ipgUrl) {
          navigate('/receipt');
          setShowBottomSheet(false);
          setIsActiveRequest(false)
        }
      },onError: ()=> {setIsActiveRequest(false)}
    })
  }
  // const handleConfirm = async () => {
  //   setIsActiveRequest(true)
  //   if (hasPasskey) {
  //     mutateLoginOptions({}, {
  //       onSuccess: async (res) => {
  //         const credential = await startAuthentication({
  //           optionsJSON: JSON.parse(res.data.loginOptions),
  //         });
  //         console.log(credential);
  //         mutateLoginComplete(credential, {
  //           onSuccess: (res) => {
  //             mutate({}, {
  //               onSuccess: (res) => {
  //                 if(res.redirectToIPG) {
  //                   window.location.assign(res.ipgUrl)
  //                 } else if(!res.redirectToIPG && !res.ipgUrl) {
  //                   navigate('/receipt');
  //                   setShowBottomSheet(false);
  //                   setIsActiveRequest(false)
  //                 }
  //               },onError: ()=> {setIsActiveRequest(false)}
  //             })
  //           },
  //         });
  //
  //       },
  //       onError: (err) => {
  //       }
  //     })
  //   } else {
  //     mutate({}, {
  //       onSuccess: (res) => {
  //         if(res.redirectToIPG) {
  //           window.location.assign(res.ipgUrl)
  //         } else if(!res.redirectToIPG && !res.ipgUrl) {
  //           navigate('/receipt');
  //           setShowBottomSheet(false);
  //           setIsActiveRequest(false)
  //         }
  //       },onError: ()=> {setIsActiveRequest(false)}
  //     })
  //   }
  // }

  return (
    <Container className='px-4'>
      {isOtpRequired &&
        <Container>
          <Text className='mb-2 mt-4 text-xl text-black dark:text-white' semiBold>
            {localization.acceptPaymentWithId('کیپا')}
          </Text>
          <Text className='text-md mb-2 text-right text-black dark:text-white'>{localization.acceptPaymentWithIdHint('کیپا')}</Text>
          <Input
            labelClassName='text-md'
            type={INPUT_TYPES.TEL}
            // error={true}
            // errorMessage={''}
            inputMode='text'
            className={cn(
              'text-md mb-1 mt-6 h-[52px] w-full border-grayLight-100 bg-grayLight-40 text-right text-grayLight-1000 focus:border-2 focus:border-black dark:border-grayDark-700 dark:bg-grayDark-900 dark:text-grayLight-0 focus:dark:border-white',
              // isError && "mb-10"
            )}
            placeholder={localization.paymentIdOtpPlaceholder}
            onChange={(e) => handleChange(e)}
            value={otp !== null ? otp : ''}
          />
          {!userAcceptOtp && (
            <Button
              className='text-md cursor-pointe mt-6 mb-8 lg:mb-4 w-full whitespace-nowrap rounded-full'
              style={{ height: '52px' }}
              size={SIZE_ENUM.XL}
              disabled={otp.length < 4}
              onClick={() => setUserAcceptOtp(true)}
            >
              {localization.confirmAnContinue}
            </Button>
          )}
        </Container>
      }
      <Container className={cn('hidden w-full flex-col pt-5', (userAcceptOtp || !isOtpRequired) && 'flex')}>
        <Text
          size={SIZE_ENUM.LG}
          className='mb-5 text-grayLight-1000 dark:text-grayLight-0'
          semiBold
        >
          {localization.finalPreInvoice}
        </Text>
        <Container
          center
          className='justify-between rounded-lg bg-grayLight-50 px-4 py-3 dark:bg-grayDark-750'
        >
          <Text className='text-black dark:text-white' medium size={SIZE_ENUM.MD}>
            {localization.totalInvoiceAmount}
          </Text>
          <Text className='text-black dark:text-white' medium size={SIZE_ENUM.MD}>
            {currency(invoice)}
            <span className='mr-1 text-[13px] text-grayLight-1000 dark:text-grayLight-0'>
              {localization.rial}
            </span>
          </Text>
        </Container>

        <Container
          center
          className={cn(
            'mt-3 w-full flex-col rounded-lg bg-grayLight-50 px-4 py-2 dark:bg-grayDark-750',
            selectedSegmentResponseItems?.length === 0 &&
              clientSelectedVouchers?.length === 0 &&
              clientSelectedVouchers?.length === 0 &&
              'hidden',
          )}
        >
          <Text
            className='my-2.5 w-full text-right text-grayLight-650 dark:text-grayDark-75'
            medium
          >
            {localization.paymentDetail}
          </Text>
          {selectedSegmentResponseItems &&
            selectedSegmentResponseItems?.map((item) => (
              <Container
                center
                className={cn('mb-4 w-full justify-between')}
                key={item?.segmentId}
              >
                <Text className='bullet text-black dark:text-white' size={SIZE_ENUM.MD}>
                  {item?.upgTitle}
                </Text>
                <span className='mx-2 flex-1 border-b border-dashed border-grayLight-30 dark:border-grayLight-850' />
                <Text className={cn('text-md text-black dark:text-grayLight-0')} medium>
                  {currency(item?.amount)}
                  <span className='mr-1 text-xs'>{localization.rial}</span>
                </Text>
              </Container>
            ))}
          {clientSelectedVouchers &&
            clientSelectedVouchers?.map((item) => (
              <Container
                center
                className={cn('mb-4 w-full justify-between')}
                key={item?.voucherId}
              >
                <Text className='bullet text-black dark:text-white' size={SIZE_ENUM.MD}>
                  {item?.discountTitle}
                </Text>
                <span className='mx-2 flex-1 border-b border-dashed border-grayLight-30 dark:border-grayLight-850' />
                <Text className={cn('text-md text-black dark:text-grayLight-0')} medium>
                  {currency(item?.discountPrice)}
                  <span className='mr-1 text-xs'>{localization.rial}</span>
                </Text>
              </Container>
            ))}
        </Container>
        {invoiceItems.map((item, index) => (
          <Container
            center
            key={index}
            className={cn(
              'mb-4 mt-3 w-full justify-between rounded-lg bg-green-50 p-4 dark:bg-green-900',
              item.value > 0 && 'bg-blue-50 dark:bg-blue-900',
            )}
          >
            <Text className='text-black dark:text-white' medium size={SIZE_ENUM.MD}>
              {item.title}
            </Text>
            <Text
              className={cn(
                'text-md text-grayLight-1000 dark:text-grayLight-0',
                item.value > 0 && 'text-blue dark:text-blue-200',
              )}
              medium
            >
              {currency(item.value)}
              <span className='mr-1 text-xs'>{localization.rial}</span>
            </Text>
          </Container>
        ))}
        <Container center className='h-[88px] w-full pb-4 '>
          <Button
            className={cn(
              'text-md h-[54px] w-full rounded-full bg-green !text-white hover:bg-green/80 dark:bg-green-500',
              ipgAmount > 0 && 'bg-blue hover:bg-blue/90 dark:bg-blue',
            )}
            onClick={handleConfirm}
            disabled={isPending || isActiveRequest || (isOtpRequired && otp.length < 4)}
            isLoading={isPending}
          >
            {/*{ipgAmount > 0 && (*/}
            {/*  <img*/}
            {/*    src={samanBankLogo}*/}
            {/*    className='ml-1'*/}
            {/*    width={40}*/}
            {/*    height={40}*/}
            {/*    alt='saman bank logo'*/}
            {/*  />*/}
            {/*)}*/}
            {ipgAmount > 0 ? localization.remainPayment : localization.acceptAndPay}
          </Button>
        </Container>
      </Container>
    </Container>
  );
}
export default PreInvoice